export const categories = [
  { id: 'rexue', name: '热血', slug: 'rexue', icon: 'ri-fire-line', description: '热血沸腾的战斗与成长故事' },
  { id: 'lianai', name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', description: '甜蜜动人的恋爱物语' },
  { id: 'xuanyi', name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', description: '扣人心弦的推理与谜团' },
  { id: 'gaoxiao', name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的欢乐日常' },
  { id: 'qihuan', name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', description: '天马行空的奇幻世界' },
  { id: 'kehuan', name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line', description: '未来科技的无限想象' },
  { id: 'maoxian', name: '冒险', slug: 'maoxian', icon: 'ri-compass-line', description: '惊险刺激的冒险之旅' },
  { id: 'richang', name: '日常', slug: 'richang', icon: 'ri-sun-line', description: '温馨治愈的日常生活' },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});